import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import DatabaseListeners from './DatabaseListeners';
import { auth } from '../../app/firebase';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../app/constants';
import { firebaseSignOut } from '../auth/authAPI';

const useStyles = makeStyles((theme) => ({
    root: {
        [theme.breakpoints.up("md")]: {
            margin: "auto",
            backgroundColor: theme.palette.common.white,
            minWidth: 960,
            maxWidth: 1400,
            marginTop: 80,
            minHeight: "80vh",
            marginBottom: 20,
        },
    }
}));

const MainLayout = ({ children }) => {
    const classes = useStyles();
    const history = useHistory();

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            if (user) {
                history.push(ROUTES.CONSULTATIONS_LIST)
            } else {
                firebaseSignOut()
            }
        })
    })

    return (
        <DatabaseListeners>
            <div className={classes.root}>
                <div className={classes.inner}>
                    {children}
                </div>
            </div>
        </DatabaseListeners>
    )
}

export default MainLayout